import Main from "../components/layout/Main";
import React, { useEffect, useState } from "react";
import Storyboard from "../containers/Storyboard/Storyboard";
import StoryboardList from "../containers/Storyboard/StoryboardList";
import { Col, Drawer, Row, Spin } from "antd";
import styles from '../containers/Storyboard/styles.module.scss'
import { StoryboardButtons } from "../containers/Storyboard/StoryboardButtons";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchWorkbooks, selectWorkbook, selectWorkbooks, setWorkbook } from "../containers/Storyboard/storyboardSlice";
import _ from "lodash";
import { StoryboardPreview } from "../containers/Storyboard/StoryboardPreview";
import { Workbook } from "../types/Storyboard";
import { useParams } from "react-router-dom";
import StoryboardIcon from './homepage/icons/svg/Storyboard.svg';
import ParentRouteRedirect from "../components/ParentRouteRedirect";

const showViz = (workbookId: string, workbooks: Workbook[] | undefined, selectedWorkbook: Workbook | undefined) => {
    return workbookId || (workbooks && workbooks.length === 1) || selectedWorkbook
}

const Workbooks = ({ workbooks }: { workbooks: Workbook[] | undefined }) => {

    const { workbookId } = useParams()
    const selectedWorkbook = useAppSelector(selectWorkbook)

    if (workbooks) {
        if (showViz(workbookId, workbooks, selectedWorkbook)) {
            return <Storyboard />
        } else {
            const previews = workbooks.map(i => {
                return <Col key={i.workbookId}><StoryboardPreview workbook={i} /></Col>
            })
            return <Row>{previews}</Row>
        }
    } else {
        return <Spin tip="Loading..." />
    }

}

const PageHeader = ({ showHeader, showDrawer }: { showHeader: boolean, showDrawer: () => void }) => {
    if (showHeader) {
        return <div className={styles.storyboardHeader}>
            <div className={styles.button_container}>
                <ParentRouteRedirect route={'/storyboard'}>
                <div className={styles.title_container}>
                    <img className={styles.logo} src={StoryboardIcon} alt="storyboard logo"/>
                    <h2 className={styles.title}>Storyboard</h2>
                </div>
                </ParentRouteRedirect>
                <div className={styles.buttons}><StoryboardButtons onClickMyStoryboards={showDrawer}/></div>
            </div>
        </div>
    }
    return null
}

type StoryboardPageProps = {
    showHeader?: boolean
    title?: string
    tag?: string | undefined
}

export const StoryboardPage = ({showHeader = true, tag = undefined}: StoryboardPageProps) => {

    const dispatch = useAppDispatch()
    const {workbookId} = useParams()
    const workbooks = useAppSelector(selectWorkbooks)
    const selectedWorkbook = useAppSelector(selectWorkbook)

    useEffect(() => {
        if (tag && workbooks) {
            const matching = workbooks.filter(w => w.tags.includes(tag))
            if (matching.length > 0) {
                dispatch(setWorkbook(matching[0]))
            }
        }
    }, [tag])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (_.isUndefined(workbooks)) {
            dispatch(fetchWorkbooks())
        }
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const [workbooksVisible, setWorkbooksVisible] = useState<boolean>(false)

    const showDrawer = () => {
        setWorkbooksVisible(true)
    }

    const closeDrawer = () => {
        setWorkbooksVisible(false)
    }

    return <Main containerClassName={showViz(workbookId, workbooks, selectedWorkbook) ? "tableau-viz" : ""}>
        <Drawer title="My Storyboards" placement="right" open={workbooksVisible} onClose={closeDrawer}>
            <StoryboardList />
        </Drawer>
        <PageHeader showHeader={showHeader} showDrawer={showDrawer} />
        <div><Workbooks workbooks={workbooks} /></div>
    </Main>
}